import $ from '../core/Dom';

export default el => {
    const button = $(el);

    const toggle = () => {
        const isOpen = button.attr('aria-expanded') === 'true';
        button.attr('aria-expanded', isOpen ? 'false' : 'true');
    };

    const init = () => {
        button.on('click', toggle);
    };

    const destroy = () => {
        button.off('click', toggle);
    };

    return {
        init,
        destroy
    };

};
